import React from "react";
import ReactSelect from "react-select";
import PropTypes from "prop-types";


class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.isValidSelected(props.selected, props.options)
                ? props.selected
                : "",
        };
    }

    componentDidUpdate(prevProps) {
        // Re-sync when parent updates selected/options
        if (
            prevProps.selected !== this.props.selected ||
            prevProps.options !== this.props.options
        ) {
            const nextSelected = this.isValidSelected(
                this.props.selected,
                this.props.options
            )
                ? this.props.selected
                : "";

            if (nextSelected !== this.state.selected) {
                this.setState({ selected: nextSelected });
            }
        }
    }

    isValidSelected = (selected, options) => {
        if (selected == null || !Array.isArray(options)) return false;
        return options.some((opt) => String(opt.value) === String(selected));
    };

    onChange = (option) => {
        const value = option?.value ?? "";
        this.setState({ selected: value });

        if (typeof this.props.onChange === "function") {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value,
                },
            });
        }
    };

    render() {
        const {
            options,
            className,
            style,
            name,
            // avoid pushing these directly via ...rest:
            selected, // eslint-disable-line no-unused-vars
            onChange, // eslint-disable-line no-unused-vars
            ...rest
        } = this.props;

        return (
            <ReactSelect
                {...rest}
                inputId={name}
                name={name}
                value={options.find((opt) => String(opt.value) === String(this.state.selected)) || null}
                onChange={this.onChange}
                className={className}
                classNamePrefix="react-select"
                style={{ ...(style || {}) }}
                options={options}
            />
        );
    }
}

Select.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.node.isRequired,
        })
    ).isRequired,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
}

Select.defaultProps = {
    selected: "",
    onChange: undefined,
    className: "",
    style: undefined,
}

export default Select;
